import { doGETRequest, doPOSTRequest, doPUTRequest } from "./Api";

class AclApi {
  public static async listAllPrivileges() {
    const relativePath = "/acl/privileges";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllRoles() {
    const relativePath = "/acl/roles";
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async createOrUpdateRole(requestDTO: any) {
    if (requestDTO.id) {
      return this.updateRole(requestDTO);
    }
    return this.createRole(requestDTO);
  }

  public static async createRole(requestDTO: any) {
    const relativePath = "/acl/roles";
    var response = await doPOSTRequest(relativePath, requestDTO);
    return response;
  }

  public static async updateRole(requestDTO: any) {
    const relativePath = "/acl/roles";
    var response = await doPUTRequest(relativePath, requestDTO);
    return response;
  }

  public static async hasPageOpenRole(role: string) {
    const relativePath = "/user-access/page-view?role=" + role;
    var response = await doGETRequest(relativePath);
    return response;
  }

  public static async listMenus() {
    const relativePath = "/user-access/menus";
    var response = await doGETRequest(relativePath);
    return response;
  }
}

export default AclApi;
